<template>
  <div class="footer_bottom">
<!--    <ul class="tab">-->
<!--      <li class="selected tab-select">-->
<!--        <a href="appindex.html"><img src="@/assets/appimg/common/bottom_navigation_1b.svg" />首页</a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a href="appsolution.html"><img src="@/assets/appimg/common/bottom_navigation_2a.svg" />解决方案</a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a href="appcooperation.html"> <img src="@/assets/appimg/common/bottom_navigation_3a.svg" />合作案例</a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a href="appinstitute.html"><img src="@/assets/appimg/common/bottom_navigation_4a.svg" />智慧农业</a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a href="appabout.html"> <img src="@/assets/appimg/common/bottom_navigation_5a.svg" />关于我们</a>-->
<!--      </li>-->
<!--    </ul>-->
    <ul class="tab">
      <li v-for="(item, index) in tabList" :key="index"
          :class="tabUrl === item.url ? 'selected tab-select' : '' "
          @click="goTab(item.url)">
          <span>
            <img v-if="tabUrl === item.url" :src="item.selectImg" />
            <img v-else :src="item.img" />
            {{ item.name }}
          </span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "FooterBottomApp",
  data () {
    return {
      tabList: [
        { name: '首页', img: require('@/assets/appimg/common/a1.svg'),
          selectImg: require('@/assets/appimg/common/a2.svg'), url: '/indexApp' },
        { name: '系统介绍', img: require('@/assets/appimg/common/b1.svg'),
          selectImg: require('@/assets/appimg/common/b2.svg'), url: '/sysIntroApp' },
        { name: '客户案例', img: require('@/assets/appimg/common/c1.svg'),
          selectImg: require('@/assets/appimg/common/c2.svg'), url: '/cooperationApp' },
        { name: '解决方案', img: require('@/assets/appimg/common/d1.svg'),
          selectImg: require('@/assets/appimg/common/d2.svg'), url: '/solutionApp' },
        { name: '关于我们', img: require('@/assets/appimg/common/e1.svg'),
          selectImg: require('@/assets/appimg/common/e2.svg'), url: '/aboutApp' },
        { name: '资讯中心', img: require('@/assets/appimg/common/f1.svg'),
          selectImg: require('@/assets/appimg/common/f2.svg'), url: '/instituteApp' },
      ],
      tabUrl: '/'
    }
  },
  mounted() {
    if (sessionStorage.getItem('tabUrl')) {
      this.tabUrl = sessionStorage.getItem('tabUrl')
    }
    console.log(sessionStorage.getItem('tabUrl'))
  },
  methods: {
    goTab(url) {
      sessionStorage.setItem('tabUrl', url)
      this.tabUrl = url
      this.setItem()
      this.$router.push(url)
      this.$nextTick(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      })
    },
    setItem() {
      sessionStorage.setItem("slt1", "");
      sessionStorage.setItem("slt2", "");
      sessionStorage.setItem("slt3", "");
      sessionStorage.setItem("slt4", "");
      sessionStorage.setItem("slt5", "");
      sessionStorage.setItem("ist1", "");
      sessionStorage.setItem("ist2", "");
      sessionStorage.setItem("ist3", "");
      sessionStorage.setItem("cpr1", "");
      sessionStorage.setItem("cpr2", "");
      sessionStorage.setItem("ab1", "");
      sessionStorage.setItem("ab2", "");
      sessionStorage.setItem("ab3", "");
      sessionStorage.setItem("ab4", "");
      sessionStorage.setItem("ab5", "");
      sessionStorage.setItem("ab6", "");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/components/footerBottom.vue